<template>

  <v-dialog v-model="dialog" width="auto">
    <v-card max-width="400" text="Please connect with the organization to access the Doubt Forum" title="Error">
      <template v-slot:actions>
        <v-btn class="ms-auto" text="Ok" @click="dialog = false"></v-btn>
      </template>
    </v-card>
  </v-dialog>
  <v-dialog v-if="showNav" v-model="emailDialog" max-width="400">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn class="text-none font-weight-regular" prepend-icon="mdi-account" text="Edit Profile" variant="tonal"
        v-bind="activatorProps"></v-btn>
    </template>

    <v-card prepend-icon="mdi-account" title="Update Email">
      <v-card-text>
        <v-row dense>

          <v-col cols="12" md="10" sm="10">
            <v-text-field label="Email*" v-model="discourseEmail" required></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text="Close" variant="plain" @click="emailDialog = false"></v-btn>

        <v-btn color="primary" text="Save" variant="tonal" @click="updateEmail"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-navigation-drawer color="navColor" v-model="navDrawer" v-if="showNav" :permanent="mdAndUp" app>
    <v-list open-strategy="single" class="t-nav">
      <!--<v-list-item prepend-icon="mdi-home" title="Home" value="home"></v-list-item>-->
      <v-list-item v-if="showNavItem('LEARN')" @click="toggleDrawer()" :active="navItemActive('/learn')" prepend-icon="mdi-book-open-variant"
        title="Learn" value="learn" to="/learn" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('TEST_SERIES')" @click="toggleDrawerForTest()" :active="navItemActive('/testseries')" prepend-icon="mdi-file-outline"
        title="Test Series" value="testseries" to="/testseries" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('PRACTICE')" @click="toggleDrawerForTest()" :active="navItemActive('/practice')" prepend-icon="mdi-file-outline"
        title="Practice" value="practice" to="/practice" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('SELF_TEST')" @click="toggleDrawer()" :active="navItemActive('/selftest')" prepend-icon="mdi-pencil-box-outline"
        title="Self Test" value="selftest" to="/selftest" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('SUBJECTIVE_TESTS')" @click="toggleDrawer()" :active="navItemActive('/subjective-tests')" prepend-icon="mdi-note-edit-outline"
        title="Subjective Tests" value="subjectivetests" to="/subjective-tests" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('COMBINED_REPORTS')" @click="toggleDrawer()" :active="navItemActive('/combinedreports')"
        prepend-icon="mdi-chart-box-outline" title="Combined Reports" value="combinedreports" to="/combinedreports"
        color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('HOMEWORK')" @click="toggleDrawer()" :active="navItemActive('/homework')" prepend-icon="mdi-bookshelf"
        title="Homework" value="homework" to="/homework" color="primary"></v-list-item>
      <v-list-item v-if="userCourse === 'JEE 2027 - 2 Year Program' && showNavItem('WORKBOOK')" @click="toggleDrawer()" :active="navItemActive('/workbook')" prepend-icon="mdi-book" title="Workbook XI 2027"
        value="workbook" to="/workbook" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('WORKBOOK_V2')" @click="toggleDrawer()" :active="navItemActive('/workbook-v2')" prepend-icon="mdi-book-edit" title="Workbook"
        value="workbook-v2" to="/workbook-v2" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('MY_CLASSES')" @click="toggleDrawer()" :active="navItemActive('/myclasses')" prepend-icon="mdi-laptop-account"
        title="Classes" value="myclasses" to="/myclasses" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('MY_NOTIFICATIONS')" @click="toggleDrawer()" :active="navItemActive('/mynotifications')" prepend-icon="mdi-bell-outline"
        title="Notifications" value="mynotifications" to="/mynotifications" color="primary">
        <template #append>
          <v-badge v-if="unreadNotificationsCount > 0" :content="unreadNotificationsCount" color="red" overlap />
        </template>
      </v-list-item>
      <v-list-item v-if="showNavItem('CALENDAR')" @click="toggleDrawer()" :active="navItemActive('/calendar')" prepend-icon="mdi-calendar"
        title="Calendar" value="calendar" to="/calendar" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('BLOGS')" @click="toggleDrawer()" :active="navItemActive('/blogs')" prepend-icon="mdi-post-outline"
        title="Blogs" value="blogs" to="/blogs" color="primary"></v-list-item>

      <v-list-item v-if="showNavItem('AI_RANK_PREDICTOR')" @click="toggleDrawer()" :active="navItemActive('/ai-rank-predictor')" prepend-icon="mdi-chart-timeline-variant" title="AI Rank Predictor" value="ai-rank-predictor" to="/ai-rank-predictor" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('VIDYA_ASSIST')" @click="toggleDrawer()" :active="navItemActive('/veeva')" prepend-icon="mdi-robot" title="Vidya Assist AI" value="veeva" to="/veeva" color="primary"></v-list-item>
      <!-- <v-list-item @click="openDoubtForum()" v-if="discourseEnabled && showNavItem('DOUBT_FORUM')" :active="false" -->
        <!-- prepend-icon="mdi-message-question-outline" title="DoubtHub" value="doubtforum" color="primary"></v-list-item> -->
      <v-list-item @click="openExternalApp('doubthub')" v-if="showNavItem('DOUBT_FORUM')" :active="false"
        prepend-icon="mdi-forum-outline" title="Doubt Hub" value="doubthub" color="primary"></v-list-item>
      <v-list-item @click="openExternalApp('chat')" v-if="showNavItem('DOUBT_HUB_CHAT')" :active="false"
        prepend-icon="mdi-chat-outline" title="Chat" value="chat" color="primary"></v-list-item>
      <v-list-item @click="openExternalApp('referral')" v-if="showNavItem('REFERRAL_PROGRAM')" :active="false"
        prepend-icon="mdi-gift-outline" title="Referral Program" value="referral" color="primary"></v-list-item>
      <v-list-item v-if="showNavItem('FEEDBACK_FORMS')" @click="toggleDrawer()" :active="navItemActive('/forms')" prepend-icon="mdi-clipboard-text"
        title="Feedback Forms" value="forms" to="/forms" color="primary">
      </v-list-item>

      <v-list-item v-if="showNavItem('BOOK_MEETING')" @click="toggleDrawer()" :active="navItemActive('/meets')" prepend-icon="mdi-human-greeting-proximity"
        title="Book Meeting" value="meets" to="/meets" color="primary">
      </v-list-item>

      <v-list-item @click="toggleDrawer()" :active="navItemActive('/terms')" prepend-icon="mdi-file-document-outline"
        title="Terms & Conditions" value="terms" to="/terms" color="primary"></v-list-item>
      <a v-if="showNavItem('NEED_SUPPORT')" href="https://support.vidyamandir.com" target="_blank" style="text-decoration: none;">
        <v-list-item :active="navItemActive('/support')" prepend-icon="mdi-face-agent" title="Need Support"
          value="calendar" color="primary"></v-list-item>
      </a>
    </v-list>
    <template v-slot:append>
      <div class="text-caption pa-2">
        v{{ appVersion }}.{{ appBuildNumber }}
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import { useDisplay } from "vuetify";
import { securePostAPI, secureGetAPI } from "@/services/apiService";
export default {
  name: "NavigationDrawer",
  setup() {
    const { mdAndUp } = useDisplay();

    return { mdAndUp };
  },
  props: {
    show: Boolean
  },
  created() {
    if (!this.mdAndUp) {
      this.$store.commit("toggleDrawer", false);
    }
    this.fetchNavigationSettings();
  },
  data: () => ({
    dialog: false,
    emailDialog: false,
    discourseEmail: "",
    navigationSettings: []
  }),
  components: {},
  computed: {
    ...mapState(["unreadNotificationsCount"]),
    ...mapState([
      "appVersion",
      "appBuildNumber",
      "navDrawer",
      "navDrawerVisible",
      "testSeriesState"
    ]),
    showNav: {
      get() {
        return this.navDrawerVisible & this.show;
      }
    },
    currentRoute: {
      get() {
        return this.$route.path;
      }
    },
    discourseEnabled: {
      get() {
        return this.$store.state.featuresEnabled.discourseEnabled ?? false;
      }
    },
    userCourse() {
      return this.$store.state.profileInfo?.organization?.course;
    },
    courseId: {
      get() {
        return this.$store.state.profileInfo?.organization?.courseId;
      }
    }
  },

  watch: {},

  methods: {
    async fetchNavigationSettings() {
      const res = await secureGetAPI({}, "mysa/navigation-settings");
      if (Array.isArray(res)) {
        this.navigationSettings = res;
      }
    },
    showNavItem(code) {
      const setting = this.navigationSettings.find(s => s.code === code);

      if (!setting) return true;
      if (setting.allStudents === true) return true;
      
      return Array.isArray(setting.courseIds) && setting.courseIds.includes(this.courseId);
    },
    updateEmail() {
      this.$store.dispatch("updateEmailForDiscourse", {
        rollNumber: this.$store.state.profileInfo.organization.rollNumber,
        email: this.discourseEmail
      })
      this.emailDialog = false
      console.log(this.$store.state.profileInfo.organization);

      this.openDiscourseUrl()
    },
    async openDoubtForum() {



      console.log(this.$store.state.profileInfo);

      if (this.$store.state.profileInfo.organization.status == true) {

        // let checkEmail = await securePostAPI({}, 'discoursetoken/checkEmail')
        // console.log(checkEmail);
        let email = this.$store.state.profileInfo.organization.email
        if (email != null && email != "null" && email.length > 0) {
          this.openDiscourseUrl()
        }
        else {
          this.dialog = true

        }

      }
      else {
        this.dialog = true
      }
    },
    async openExternalApp(appType) {
      // All three apps are launched the same way: exchange this student's
      // own long-lived session token for a fresh single-use SSO token via
      // VMCDoubtsSSO's generate/student, then open that app's own
      // /sso?token=... landing page. This keeps the real session token from
      // ever being forwarded into another app's URL (it only ever proves
      // identity to generate/student, here, first-party).
      const APPS = {
        doubthub: { url: "https://doubthub.vidyamandir.com" },
        chat: { url: "https://chat.vidyamandir.com" },
        referral: { url: "https://wallet.vidyamandir.com" }
      };
      // Derived from this app's own already-resolved, per-environment API
      // base URL (see fetchAPIUrls()/apiBaseUrl) rather than hardcoded —
      // VMCDoubtsSSO is deployed per-environment (devtest/prod each have
      // their own cognitoUsers/students tables), so a hardcoded prod URL
      // would 403 here whenever this app is running against devtest.
      const SSO_ENDPOINT = `${this.$store.getters.apiBaseUrl}VMCDoubtsSSO/generate/student`;

      const app = APPS[appType];
      if (!app) {
        console.error("Unknown external app type:", appType);
        return;
      }

      const accessToken = localStorage.getItem('accessToken');
      try {
        const response = await fetch(SSO_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ accessToken })
        });
        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          console.error("SSO error:", response.status, err);
          alert(`Failed to generate SSO token (${response.status}). Please try again.`);
          return;
        }
        const data = await response.json();
        if (data.success && data.accessToken) {
          window.open(`${app.url}/sso?token=${data.accessToken}`, '_blank');
        } else {
          alert("Unexpected response from SSO.");
        }
      } catch (e) {
        console.error("SSO error:", e);
        alert("Network error while generating SSO token. Please try again.");
      }
    },
    async openDiscourseUrl() {
      let discourseToken = await securePostAPI({}, 'discoursetoken/gen')
      console.log(discourseToken);

      const url = `${this.$store.getters.apiBaseUrl}discoursetoken/cookies?token=${discourseToken.token}`;
      window.open(url, "_blank");
    },
    navItemActive(item) {
      // Exact match always wins
      if (this.currentRoute === item) return true;
      // Prefix match only for child routes (e.g. /homework/:id), not sibling routes like /workbook vs /workbook-v2
      if (this.currentRoute.startsWith(item + '/')) return true;
      return false;
    },
    toggleDrawer() {
      if (!this.mdAndUp) {
        this.$store.commit("toggleDrawer", !this.navDrawer);
      }
    },
    toggleDrawerForTest() {
      if (!this.mdAndUp) {
        this.$store.commit("toggleDrawer", !this.navDrawer);
      }
      this.$store.commit("updateTestSeriesState", {
        submissionData: this.testSeriesState.submissionData,
        clear: true
      });
    }
  }
};
</script>

<style scoped>
.t-nav {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: black !important;
}
</style>
